<template>
  <div class="usePageBox">
    <div v-if="true" class="topBox">
      <div class="leftBox">
        <AutoComplete size="large" placeholder="输入订单号，商户名搜索" icon="ios-search" clearable
                      @on-search="searchOrderNameCallback" @on-select="selectOrderNameCallback">
          <Option v-for="item in searchOrderList" :value="item.inner_no" :key="item.inner_no">
            {{item.inner_no}}-{{item.deliver_user_name}}
          </Option>
        </AutoComplete>
      </div>
      <div class="rightBox">
        <div>
          <RadioGroup type="button" size="large" v-model="searchParams.packStatus"
                      @on-change="changeStatusCallback">
            <Radio :label="0">全部</Radio>
            <Radio :label="1" style="background-color: #669933;color: #F0F0F0">待分拣</Radio>
            <Radio :label="3" style="background-color: #666666;color: #F0F0F0">缺货</Radio>
            <Radio :label="2" style="background-color: #6699CC;color: #F0F0F0">已分拣</Radio>
          </RadioGroup>
          <Button style="height: 38px;" type="success" @click="showOrderTurnover">周转物</Button>
          <Button style="height: 38px;" @click="showOrderBoxList" v-if="$store.state.softwareSetting.openBox==1">装箱列表</Button>
        </div>
        <div>
					<span style="right: 0px;">
						<a @click="showSearch">更多筛选<Icon type="ios-arrow-forward"/></a>
					</span>
        </div>
      </div>
    </div>
    <div v-if="true" class="contentBox">
      <div class="leftBox">
        <div class="skuBoxArea" style="width:240px;height:100%;overflow:hidden; overflow-y:scroll;background:white">
          <!-- @on-select="queryPackBySkuId" -->
          <div class="skuBox">
            <div @click="toSelect(item)" :class="currentOrder.inner_no==item.inner_no?'active':''"
                 v-for="(item,index) in orderList" :key="item.inner_no" class="skuItem">
              <div class="textBox" style="font-size:17px" :id="'text' + item.inner_no">
                {{item.inner_no}}<br/>
                <span v-if="item.delivery_type==4">
									{{item.deliver_user_name}}
									<span v-if="item.buyer && item.buyer.reciver_name">({{item.buyer.reciver_name}})</span>
								</span>
                <span v-else>{{item.deliver_user_name}}</span>

                <div class="countNum" v-if="item.wait_count > 0">
                  <div class="numtext">{{ item.wait_count }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <Row>
          <Col style="height:78vh;" :flex="1">
            <Spin fix v-if="loading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"/>
              <div>Loading</div>
            </Spin>
            <div v-for="(is_weight, is_weight_index) in [1,2]" :key="is_weight_index">
              <Divider v-if="is_weight==1"><b>以下为计重商品</b></Divider>
              <Divider v-if="is_weight==2"><b>以下为非计重商品</b></Divider>
              <div v-for="(isWeightItem, key) in skuCategoryList" :key="key" v-if="key==is_weight">
                <div v-for="(isSortItem, isSortSky) in isWeightItem" :key="isSortSky">
                  <div v-for="(categoryItem, categoryKey) in isSortItem" :key="categoryKey">
                    <Divider orientation="left">
                      <b>{{categoryItem[0]&&categoryItem[0].sku_category_title?categoryItem[0].sku_category_title:'无分类'}}</b>
                    </Divider>
                    <Row :gutter="20" v-if="!loading">
                      <!-- 分拣单品展示区域 -->
                      <Col :sm="24" :md="12" :lg="12" :xl="8" :xxl="8" v-for="(item,itemIndex) in packDatas" :key="item.id"
                           v-if="categoryKey==item.sku_category && item.is_weight==is_weight" style="margin-bottom: 40px;">
                        <!-- 溯源-分拣绑定入库批次 -->
                        <!--<span v-for="(item, index) in skuBatchNoList"
                              v-if="packDatas.length && $store.state.platform_setting.moduleArr.includes('traceSource') && key==item.skuId && item.batch_nos.length">
                          <Select style="width:200px" v-model="batchNoSelect[index]" size="large">
                            <Option v-for="itema in item.batch_nos" :value="itema" :key="itema">{{ itema }}</Option>
                          </Select>
                        </span>-->
                        <!-- 路线展示标签 -->
                        <div style="line-height: 40px">
                          <Checkbox v-model="item._checked" :true-value="1" :false-value="0"
                                    @on-change="selectDataCallback(item,itemIndex)" v-if="$store.state.softwareSetting.openBox==1"
                                    :disabled="item.lack_status==2 || item.status>61|| item.packing_type==2"/>
                          路线：{{ item.lineTitle ? item.lineTitle : "无路线" }}
                          <span v-if="sortingNoData.noLine">
                            <!--<span v-if="searchParams.lineId">{{sortingNoData[searchParams.lineId][item.id]}}</span>-->
                            <span v-if="item.lineId && sortingNoData[item.lineId]">{{sortingNoData[item.lineId][item.id]}}</span>
                            <span v-else>{{sortingNoData.noLine[item.id]}}</span>
                          </span>
                        </div>

                        <!-- 具体内容展示区域 -->
                        <div class="areaBox">
                          <div class="cardLeft" :style="{'background-color': getBackgroundColor(item)}"
                               @click="changeSortingDataSwitch(item)">
                            <div style="margin:7px;font-size: 20px;font-weight: bold;color: #f3f3f3;">
                              <!--<Badge :count="index+1"></Badge>-->
                              <span>{{item.sku_name}}</span>
                            </div>
                            <div style="text-align: center;">
                              <b style="line-height: 40px;"
                                 :style="{fontSize:(item.showUnit.toString().length>7?'28px':item.showUnit.toString().length>2?'32px':'37px')}">
                                {{item.showUnit}}
                              </b>
                              <p v-if="item.realWeight>=0 && flush">
                                ({{item.is_weight==1?"称重":"拣出"}}:{{ item.showSortingUnit }})
                              </p>
                              <p v-if="item.lack_status==2" style="color: #fb4747">(缺货)</p>
                            </div>
                            <div style="margin:7px;font-size: 14px;">
                              备注：{{ item.order_note }}
                            </div>
                          </div>
                          <div class="cardRight mycardRight">
                            <Button class="top" @click="showKeyboard(item)" :disabled="item.lack_status==2 || item.status>61">
                              <b>输入</b>
                            </Button>
                            <div class="top">
                              <Poptip style="height:100%" placement="right">
                                <Button style="height:100%" class="buttom">
                                  <b>操作</b>
                                </Button>
                                <div slot="content">
                                  <ButtonGroup vertical size="large">
                                    <Button :disabled="item.status==CONSTANT.DELIVER_STATE_KEY.PACK_NO"
                                            @click="printData(item,1)">
                                      打印标签
                                    </Button>
                                    <Button :disabled="item.lack_status==2 || item.status>CONSTANT.DELIVER_STATE_KEY.PACK_NO"
                                            @click="editSortingLackStatus(item)"
                                            v-if="item.lack_status==1">
                                      标记缺货
                                    </Button>
                                    <Button @click="editSortingLackStatus(item)" v-if="item.lack_status==2">
                                      标记有货
                                    </Button>
                                    <Button @click="doWholeBox(item)"
                                            v-if="$store.state.softwareSetting.openBox==1 && !item.packingBoxCount &&
                                            item.packing_type==2">
                                      整件装箱
                                    </Button>
                                    <Button @click="cancelBox(item)"
                                            v-if="$store.state.softwareSetting.openBox==1 && item.packingBoxCount">
                                      取消装箱
                                    </Button>
                                  </ButtonGroup>
                                </div>
                              </Poptip>
                            </div>

                          </div>
                        </div>
                        <a v-if="item.packingBoxCount">已装{{item.packingBoxCount}}箱</a>
                        <sortingTurnbox :sortingData="item"/>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <search ref="search" :searchParams="searchParams" :carLine="carLine" @reciveSearchData="reciveSearchData"/>
    <keyboard ref="keyboard" @reciveData="reciveKeyboardData" :canDecimal="canDecimal"/>
    <weightReading @reciveData="reciveData" ref="weightReading"/>
    <div id="qrcode" v-show="false"/>
    <!--条形码-->
    <img id="jsbarcode" v-show="false"/>
    <orderTurnbox ref="orderTurnover" :sortingData="currentOrder" @submit="updateOrderTurnoverCallback"/>
    <joinBox v-if="$store.state.softwareSetting.openBox==1" :selectDatas="selectDatas" @submitJoinBox="submitJoinBoxCallback"/>
    <cancelBox ref="cancelBox" @cancelBoxSubmit="cancelBoxSubmitCallback"/>
    <orderBoxList ref="orderBoxList" @reciveChangeData="submitJoinBoxCallback"/>
    <globalPrint ref="globalPrint"/>
  </div>
</template>

<script>
  import config from '@/config'

  const h5PageUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.h5PageDev : config.baseUrl.h5PagePro;
  const CONSTANT = require("../../../common/const");
  const timeUtil = require("@/libs/timeUtil");
  const qrcode = require("qrcodejs2");
  const JsBarcode = require("jsbarcode");
  import keyboard from "_c/keyboard";
  import weightReading from "_c/weightReading";
  import sortingTurnbox from "_c/sortingTurnbox/sortingTurnbox";
  import orderTurnbox from "_c/sortingTurnbox/orderTurnbox";
  import {
    getSortingDataById,
    querySortingListByOrder,
    queryCarLine,
    editSortingStandard,
    editSorting,
    editSortingLackStatus,
    getPrintTemplate,
    querySortingByOrder,
    initSortingNo
  } from '@/api/sorting/sorting';
  import {getBackgroundColor} from '@/libs/tools';
  import {changeUnit, getUnitAndBaseUnit, getHasSortingUnitAndBaseUnit} from "@/libs/util";
  import {add, reduce, mul, div} from "../../util/NumberUtil";

  import {printByTemplate, printByTemplateV2} from "../../util/printUtil";

  // 溯源-非标品/标品拣货台-SPU—SKU—入库批次号查询
  // import {querySkuBatchNoByOrder} from "@/api/traceSource/trace_source";
  import {doPackingBoxByPackIds} from "@/api/sorting/packingBox";

  export default {
    name: 'weightSorting',
    components: {keyboard, weightReading, sortingTurnbox, orderTurnbox},
    data() {
      return {
        flush: true, // 处理数据不刷新
        CONSTANT,
        getBackgroundColor: getBackgroundColor,
        workbenchId: 0, // 工作台id
        canDecimal: false, // 软键盘是否可以输入小数
        loading: false,
        // 订单列表
        orderList: [],
        // 分拣sku列表
        // skuList: [],
        skuCategoryList: [],
        // 检索订单列表
        searchOrderList: [],
        // 当前选中sku
        currentOrder: {},
        // 当前选择分拣数据
        currentSortingData: {},
        // 查询参数
        searchParams: {
          // title: "",
          lineId: null,
          packStatus: 0,
          distributor: null,
          supplierId: null,
          dateType: this.$store.state.dateType,
          // sort: this.$store.state.softwareSetting.sortingMoved
        },
        // 拣货数据
        packDatas: [],
        // 开启图片分拣
        // openPic: false,
        // 配送路线
        carLine: [],
        // 当前电子秤读数、输入数量 非标品
        currentWeightData: 0,
        // 当前电子秤读数、输入数量 标品
        currentNumData: 0,
        // 小票模板
        printTemplate: {},
        // 溯源-分拣绑定入库批次
        skuBatchNoList: [], // sku列表，数据结构:[{skuId,batch_nos:批次号数组}]
        batchNoSelect: [],  // 当前选择批次数组，与sku一一对应
        sortingNoData: {}, // 分拣序号数据
        // 电子秤读数接收完成
        reciveWeightComplete: false,
        //当前重量接收来源 1电子秤 2数字键盘
        weightFromType: null,
        // 已选的数据
        selectDatas: [],
      }
    },
    methods: {
      // 打开筛选窗口
      showSearch() {
        this.$refs.search.showSearchModal();
      },
      reciveSearchData(data) {
        this.querySortingByOrder();
      },
      // 选择sku
      toSelect(item) {
        // this.currentOrderId = item.groupSkuId;
        this.currentOrder = item;
        this.querySortingListByOrder();
      },
      // 打开数字键盘
      showKeyboard(data) {
        this.currentSortingData = data;
        this.canDecimal = false;
        if (this.currentSortingData.is_weight === 1)
          this.canDecimal = true;
        this.$refs.keyboard.showKeyboardModal(data);
      },
      // 刷新待分拣数量
      reflushWaitSortingCount() {
        let count = 0;
        for (let i = 0; i < this.packDatas.length; i++) {
          if (this.packDatas[i].status == CONSTANT.DELIVER_STATE_KEY.PACK_NO) {
            count++;
          }
        }
        this.currentOrder.wait_count = count;
        // 散件自动标记任务
        if (this.$store.state.softwareSetting.openBox == 1 && this.$store.state.softwareSetting.autoPartBoxTask == 1
          && this.currentSortingData.packing_type == 1) {
          this.currentSortingData._checked = 1;
          let has = false;
          for (let item of this.selectDatas) {
            if (item.id == this.currentSortingData.id) {
              has = true;
              break;
            }
          }
          if (!has)
            this.selectDatas.push(this.currentSortingData);
        }
        // 整件自动装箱
        if (this.$store.state.softwareSetting.openBox == 1 && this.$store.state.softwareSetting.autoWholeBox == 1) {
          this.flushPackingBox([this.currentSortingData.id], 1);
        }
      },
      // 查询订单
      querySortingByOrder() {
        return new Promise((resolve, reject) => {
          if (this.$store.state.sortingTimeSetting.sortingStartTime) {
            let param = {...this.searchParams};
            param.packTime = [this.$store.state.sortingTimeSetting.sortingStartTime, this.$store.state.sortingTimeSetting.sortingEndTime];
            param.spuCategoryIds = this.$store.state.sortingTimeSetting.spuCategoryIds;
            querySortingByOrder(param).then(res => {
              if (res.status === 200) {
                this.orderList = res.data.data.rows;
                this.workbenchId = res.data.data.workbenchId;
                if (this.orderList.length) {
                  this.currentOrder = this.orderList[0];
                }
                this.querySortingListByOrder();
              }
            });
          }
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 查询sku拣货数据
      querySortingListByOrder() {
        this.selectDatas = [];
        if (!this.currentOrder.inner_no) return;
        this.searchParams.innerNo = this.currentOrder.inner_no;
        this.searchParams.packTime = [this.$store.state.sortingTimeSetting.sortingStartTime, this.$store.state.sortingTimeSetting.sortingEndTime];
        this.searchParams.spuCategoryIds = this.$store.state.sortingTimeSetting.spuCategoryIds;
        this.searchParams.sort = this.$store.state.softwareSetting.sortingMoved;
        return new Promise((resolve, reject) => {
          this.loading = true;
          querySortingListByOrder(this.searchParams).then(res => {
            if (res.status === 200) {
              this.packDatas = res.data.data.datas;
              // this.skuList = res.data.data.skuData;
              let skuCategoryList = res.data.data.skuCategoryData;
              let waitCount = 0; // 当前sku分拣数据量
              this.skuCategoryList = {1: {1: {}, 2: {}}, 2: {1: {}, 2: {}}};
              if (skuCategoryList[1]) {
                for (let cate in skuCategoryList[1]) {
                  let isTag = false;
                  for (let i = 0; i < skuCategoryList[1][cate].length; i++) {
                    if (skuCategoryList[1][cate][i].status == CONSTANT.DELIVER_STATE_KEY.PACK_NO) { // 有待分拣
                      isTag = true;
                      break;
                    }
                  }
                  if (isTag) { // 有待分拣，展示到前边
                    this.skuCategoryList[1][1][cate] = skuCategoryList[1][cate];
                  } else { // 无待分拣，后移
                    this.skuCategoryList[1][2][cate] = skuCategoryList[1][cate];
                  }
                }
              }
              if (skuCategoryList[2]) {
                for (let cate in skuCategoryList[2]) {
                  let isTag = false;
                  for (let i = 0; i < skuCategoryList[2][cate].length; i++) {
                    if (skuCategoryList[2][cate][i].status == CONSTANT.DELIVER_STATE_KEY.PACK_NO) { // 有待分拣
                      isTag = true;
                      break;
                    }
                  }
                  if (isTag) { // 有待分拣，展示到前边
                    this.skuCategoryList[2][2][cate] = skuCategoryList[2][cate];
                  } else { // 无待分拣，后移
                    this.skuCategoryList[2][2][cate] = skuCategoryList[2][cate];
                  }
                }
              }
              console.log("this.skuCategoryList", this.skuCategoryList);
              for (let i = 0; i < this.packDatas.length; i++) {
                // 应分拣数量 箱|10斤
                let base_unit = this.packDatas[i].base_unit, unit = this.packDatas[i].product_cache.specifications,
                  unit_conversion = this.packDatas[i].unit_conversion, is_weight = this.packDatas[i].is_weight;
                if (this.packDatas[i].extend) {
                  this.packDatas[i].unit = this.packDatas[i].extend.unit;
                  this.packDatas[i].realWeight = this.packDatas[i].extend.weight;
                  if (this.packDatas[i].is_weight == 1) {
                    this.packDatas[i].realWeight = changeUnit(this.packDatas[i].extend.weight, "g", base_unit);
                    // this.packDatas[i].unit = "斤";
                    let showUnitData = getHasSortingUnitAndBaseUnit({
                      base_unit,
                      weightG: this.packDatas[i].extend.weight,
                      unit,
                      unit_conversion,
                      is_weight
                    });
                    this.packDatas[i].showSortingUnit = showUnitData.showUnit;
                  } else {
                    let showUnitData = getHasSortingUnitAndBaseUnit({
                      base_unit,
                      weightG: this.packDatas[i].extend.weight,
                      unit,
                      unit_conversion,
                      is_weight
                    });
                    this.packDatas[i].showSortingUnit = showUnitData.showUnit;
                  }
                } else {
                  this.packDatas[i].unit = this.packDatas[i].product_cache.specifications;
                  // if (this.packDatas[i].is_weight == 1) {
                  //   this.packDatas[i].unit = "斤";
                  // }
                }
                if (!this.packDatas[i].product_cache) {
                  // 兼容旧数据
                  this.packDatas[i].product_cache = {};
                }
                if (this.packDatas[i].is_weight == 1) {
                  let num = this.packDatas[i].product_num;
                  let goodsWeight = mul(this.packDatas[i].product_cache.weight, num);
                  let showUnitData = getUnitAndBaseUnit({
                    base_unit, weightG: goodsWeight, unit, num,
                    unit_conversion, is_weight
                  });
                  this.packDatas[i].showUnit = showUnitData.showUnit;
                } else {
                  let num = this.packDatas[i].product_num;
                  let showUnitData = getUnitAndBaseUnit({base_unit, unit, num, unit_conversion, is_weight});
                  this.packDatas[i].showUnit = showUnitData.showUnit;
                }
                // 应出
                /*if (this.packDatas[i].is_weight == 1) {
                    this.packDatas[i].originWeight = this.packDatas[i].product_cache.weight;
                    if (!this.packDatas[i].product_cache.weight)
                        this.packDatas[i].originWeight = 0;
                } else {
                    this.packDatas[i].originWeight = this.packDatas[i].product_num;
                }
                // 单位转换
                if (this.packDatas[i].is_weight == 1)
                    this.packDatas[i].originWeight = changeUnit(this.packDatas[i].originWeight * this.packDatas[i].product_num, "g", "斤");*/

                for (let j = 0; j < this.carLine.length; j++) {
                  if (this.carLine[j].grouper_ids) {
                    if (this.carLine[j].grouper_ids.includes(this.packDatas[i].deliver_user)) {
                      this.packDatas[i].lineTitle = this.carLine[j].title;
                      this.packDatas[i].lineId = this.carLine[j].id;
                    }
                  }
                }
                // if (this.packDatas[i].status == CONSTANT.DELIVER_STATE_KEY.PACK_NO) {
                waitCount++;
                // }

                // if(this.packDatas[i].status == CONSTANT.DELIVER_STATE_KEY.PACK_NO){ // 有未分拣
                //   skuCategoryMap[this.packDatas[i].is_weight][this.packDatas[i].sku_category] = true;
                // }
              }
              if (waitCount > this.currentOrder.count)
                this.currentOrder.count = waitCount;
              this.loading = false;

              // 溯源-分拣绑定入库批次
              // if (this.$store.state.platform_setting && this.$store.state.platform_setting.moduleArr.includes("traceSource")) {
              // 	this.querySkuBatchNoByOrders()
              // }
              if (this.$store.state.platform_setting && this.$store.state.platform_setting.moduleArr.includes("sortingNo")) {
                this.initSortingNo();
              }

            }
          });
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 溯源-非标品/标品拣货台-SPU—SKU—入库批次号查询
      /*querySkuBatchNoByOrders() {
          if (this.currentOrder.inner_no) {
              return new Promise((resolve, reject) => {
                  querySkuBatchNoByOrder({inner_no: this.currentOrder.inner_no}).then(data => {
                      if (data.data.code === 1200) {
                          this.batchNoSelect = [];
                          this.skuBatchNoList = data.data.data;
                          for (let i = 0; i < this.skuBatchNoList.length; i++) {
                              this.batchNoSelect.push(this.skuBatchNoList[i].batch_nos[0])
                          }
                      }
                      resolve(data)
                  }).catch(err => {
                      this.$Message.error(err);
                      reject(err)
                  })
              })
          }
      },*/
      // 查询配送路线
      queryCarLine() {
        return new Promise((resolve, reject) => {
          queryCarLine().then(res => {
            if (res.status === 200) {
              this.carLine = res.data.data;
            }
          });
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 获取分拣序号
      initSortingNo() {
        return new Promise((resolve, reject) => {
          initSortingNo(this.searchParams).then(res => {
            if (res.status === 200) {
              this.sortingNoData = res.data.data;
              // 添加分拣序号
              if (this.sortingNoData.noLine) {
                for (let i = 0; i < this.packDatas.length; i++) {
                  let sortingNo = this.sortingNoData.noLine[this.packDatas[i].id];
                  if (this.packDatas[i].lineId && this.sortingNoData[this.packDatas[i].lineId]) {
                    sortingNo = this.sortingNoData[this.packDatas[i].lineId][this.packDatas[i].id];
                  }
                  if (this.searchParams.lineId && this.sortingNoData[this.searchParams.lineId]) {
                    sortingNo = this.sortingNoData[this.searchParams.lineId][this.packDatas[i].id];
                  }
                  // this.packDatas[i].sortingNo = sortingNo;
                  this.$set(this.packDatas[i], "sortingNo", sortingNo);
                  // console.log(sortingNo)
                }
              }
            }
          });
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 选择路线回调查询
      changeCarCallback(event) {
        if (!event) {
          delete this.searchParams.grouper_ids;
          return this.querySortingByOrder();
        }
        let grouper_ids = [];
        for (let i = 0; i < this.carLine.length; i++) {
          if (event == this.carLine[i].id) {
            grouper_ids = this.carLine[i].grouper_ids;
          }
        }
        this.searchParams.grouper_ids = grouper_ids;
        this.querySortingByOrder();
      },
      // 接收称重数据
      reciveData(data) {
        this.currentWeightData = Number(data.data);
        this.weightFromType = 1
        this.reciveWeightComplete = true;
      },
      // 接收数字键盘数据
      reciveKeyboardData(data) {
        let number = Number(data.data);
        this.weightFromType = 2
        this.changeSortingDataSwitch(this.currentSortingData, number);
      },
      // 判断执行标品还是非标品
      changeSortingDataSwitch(data, number) {
        if (data.is_weight == 1) {
          if (typeof number != 'undefined') {
            this.currentWeightData = number;
          }
          this.changeSortingData(data);
        } else {
          this.changeSortingData2(data, number);
        }
      },
      // 选择分拣数据 更新称重
      changeSortingData(data) {
        this.currentSortingData = data;
        if (data.lack_status == 2) {
          return;
        }
        // 判断电子秤接收状态是否完成
        if (!this.reciveWeightComplete && !this.currentWeightData) {
          // console.log("电子秤读数未初始化完毕")
          return this.$Message.warning("电子秤读数未初始化完毕，请稍后！");
        }
        // 已打包状态只打印标签
        if (this.currentSortingData.status == CONSTANT.DELIVER_STATE_KEY.PACK_COMPLETE) {
          // console.log("打印标签");
          return this.printData(this.currentSortingData);
        }
        let bool = this.checkWeighingRemind();
        if (!bool) {
          this.$Modal.confirm({
            title: "称重差异提醒",
            content: "实际称重量与下单量差异过大，是否继续？",
            onOk: () => {
              this.doWeightSorting();
            },
            onCancel: () => {
            }
          });
        } else {
          this.doWeightSorting();
        }
      },
      // 根据重量接受来源获取重量转换单位
      getBaseUnitOfFromType() {
        let that = this;
        let baseUnit = null;
        if (that.weightFromType == 1) {
          // 重量来源于电子秤
          let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
          baseUnit = (unitValue == 1?'斤':'kg')
        } else {
          baseUnit = this.currentSortingData.base_unit
        }
        return baseUnit;
      },
      doWeightSorting() {
        // 未分拣的分拣
        if (this.currentSortingData.status == CONSTANT.DELIVER_STATE_KEY.PACK_NO || this.currentSortingData.status == CONSTANT.DELIVER_STATE_KEY.PACK_WATI) {
          if (!this.currentWeightData) {
            this.$Modal.confirm({
              title: "称重量为0，是否继续分拣",
              content:
                "<p></p>",
              onOk: () => {
                this.currentSortingData.extend = {weight: 0, unit: "g"};
                if(this.currentSortingData.showExtend) {this.currentSortingData.showExtend.weight = 0};
                this.flushSortingData();
              },
              onCancel: () => {
              }
            });
          } else {
            //根据重量接收来源 1电子秤 2数字键盘  来设置重量转换的基本单位
            let basicUnit
            if(this.weightFromType == 1) {
              let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
              basicUnit = (unitValue == 1?'斤':'kg')
            } else {
              basicUnit = this.currentSortingData.base_unit
            }
            this.currentSortingData.extend = {weight: changeUnit(this.currentWeightData, basicUnit, "g"), unit: "g"};
            if (this.currentWeightData == this.currentSortingData.realWeight) {
              // 已分拣并且再次点击拣出数量没有变的情况下只打印标签
              console.log("打印标签", this.currentWeightData, this.currentSortingData);
              return this.printData(this.currentSortingData);
            } else {
              this.flushSortingData();
            }
          }
        } else {
          this.flushSortingData();
        }
      },
      // 检测称重阈值
      checkWeighingRemind() {
        // 判断是否开启称重差异阈值
        if (this.$store.state.softwareSetting.weighingRemind == 1 && this.$store.state.softwareSetting.weighingRemindSize > 0) {
          // 计算差值
           console.log("currentSortingData", this.currentSortingData)
          let nowWeight = changeUnit(this.currentWeightData, this.getBaseUnitOfFromType(), "g");
          let diffWeight = this.currentSortingData.weight - nowWeight;
          // console.log("差异", diffWeight)
          let diffScale = Number(diffWeight / this.currentSortingData.weight).toFixed(2);
          // console.log("差异百分比", diffScale)
          if (Math.abs(diffScale * 100) >= this.$store.state.softwareSetting.weighingRemindSize) {
            // console.log("超限提醒")
            return false;
          }
        }
        return true;
      },
      // 选择分拣数据 更新称重 标品
      changeSortingData2(data, number) {
        // keyboardCakkback 是否是键盘输入回调，是的话需要重新
        if (data.lack_status == 2) {
          return;
        }
        this.currentSortingData = data;
        // console.log(number)
        // console.log(this.currentSortingData)
        // console.log(this.currentWeightData)
        if (!number) {
          this.currentNumData = this.currentSortingData.product_num;
          // 分拣过的实际数量
          if (this.currentSortingData.hasOwnProperty("realWeight"))
            this.currentNumData = this.currentSortingData.realWeight;

          this.currentSortingData.realWeight = this.currentNumData;
        } else {
          this.currentNumData = number;
          this.currentSortingData.realWeight = number;
        }

        // 已打包状态只打印标签
        if (this.currentSortingData.status == CONSTANT.DELIVER_STATE_KEY.PACK_COMPLETE) {
          // console.log("打印标签");
          return this.printData(this.currentSortingData);
        }
        // 如果没有录入检出量并且未分拣，默认拣出购买量
        if (this.currentSortingData.status == CONSTANT.DELIVER_STATE_KEY.PACK_NO) {
          let unit = this.currentSortingData.product_cache.specifications;
          this.currentSortingData.extend = {weight: this.currentSortingData.product_num, unit};
          this.flushSortingData();
        } else if (this.currentNumData == this.currentSortingData.extend.weight) {
          this.flushSortingData();
        } else {
          this.flushSortingData();
        }
      },
      // 刷新并提交分拣
      flushSortingData() {
        this.flush = false;
        let base_unit = this.currentSortingData.base_unit, unit = this.currentSortingData.product_cache.specifications,
          unit_conversion = this.currentSortingData.unit_conversion, is_weight = this.currentSortingData.is_weight;
        if (this.currentSortingData.is_weight == 1) {
          this.currentSortingData.realWeight = this.currentWeightData;
          //根据重量接收来源 1电子秤 2数字键盘  来设置重量转换的基本单位
          let basicUnit
          if(this.weightFromType == 1) {
            let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
            basicUnit = (unitValue == 1?'斤':'kg')
          } else {
            basicUnit = this.currentSortingData.base_unit
          }
          let showUnitData = getHasSortingUnitAndBaseUnit({
            base_unit,
            weightG:changeUnit(this.currentWeightData, basicUnit, "g"),
            unit,
            unit_conversion,
            is_weight
          });
          this.currentSortingData.showSortingUnit = showUnitData.showUnit;
        } else {
          this.currentSortingData.realWeight = this.currentNumData;
          let showUnitData = getHasSortingUnitAndBaseUnit({
            base_unit,
            weightG: this.currentNumData,
            unit,
            unit_conversion,
            is_weight
          });
          this.currentSortingData.showSortingUnit = showUnitData.showUnit;
        }
        this.flush = true;
        // 已打包配送的不更新，只打印标签
        if (this.currentSortingData.status != CONSTANT.DELIVER_STATE_KEY.PACK_COMPLETE) {
          this.editSorting();
        }
        // 首次分拣后移
        if (this.$store.state.softwareSetting.sortingMoved == 1) {
          if (this.currentSortingData.status == CONSTANT.DELIVER_STATE_KEY.PACK_NO) {
            let index;
            for (let i = 0; i < this.packDatas.length; i++) {
              if (this.currentSortingData.id == this.packDatas[i].id) {
                index = i;
              }
            }
            if (index >= 0) {
              this.packDatas.splice(index, 1);
              this.packDatas.push(this.currentSortingData);
            }
          }
        }
      },
      // 更新分拣数据
      editSorting() {
        return new Promise((resolve, reject) => {
          // console.log(this.currentSortingData)
          let realWeight = this.currentSortingData.realWeight;
          //根据重量接收来源 1电子秤 2数字键盘  来设置重量转换的基本单位
          let basicUnit
          if(this.weightFromType == 1) {
            let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
            basicUnit = (unitValue == 1?'斤':'kg')
          } else {
            basicUnit = this.currentSortingData.base_unit
          }
          realWeight = changeUnit(realWeight, basicUnit, "g");

          if (this.currentSortingData.is_weight == 2) {
            realWeight = this.currentSortingData.realWeight;
          }
          let param = {id: this.currentSortingData.id, workbenchId: this.workbenchId, realWeight};
          /*for (let i = 0; i < this.skuBatchNoList.length; i++) {
              if (this.skuBatchNoList[i].skuId == this.currentSortingData.sku_id) {
                  param.batch_no = this.batchNoSelect[i];
              }
          }*/
          // 添加称重框参数
          if (this.$store.state.boxSetting && this.$store.state.boxSetting.selectBoxList.length) {
            param.boxSetting = this.$store.state.boxSetting;
          }
          // 整件自动装箱
          if (this.$store.state.softwareSetting.openBox == 1) {
            param.autoWholeBox = this.$store.state.softwareSetting.autoWholeBox;
          }
          // return console.log(param)
          if (this.currentSortingData.is_weight == 1) {
            editSorting(param).then(data => {
              if (data.data.code === 1200) {
                // 更新可分拣数量
                this.currentSortingData.status = CONSTANT.DELIVER_STATE_KEY.PACK_WATI;
                if (this.$store.state.boxSetting && this.$store.state.boxSetting.autoLent == "true" && this.$store.state.boxSetting.selectBoxList && this.$store.state.boxSetting.selectBoxList.length) {
                  let boxTitles = "";
                  for (let i = 0; i < this.$store.state.boxSetting.selectBoxList.length; i++) {
                    boxTitles += this.$store.state.allTurnoverBoxsObj[this.$store.state.boxSetting.selectBoxList[i].id].title + "*" + this.$store.state.boxSetting.selectBoxList[i].count + " "
                  }
                  this.currentSortingData.boxTitles = boxTitles;
                }
                this.reflushWaitSortingCount();
                this.printData(this.currentSortingData);
              } else {
                this.querySortingListByOrder();
                this.$Notice.error({title: "分拣异常", desc: data.data.msg});
              }
            });
          } else {
            editSortingStandard(param).then(data => {
              if (data.data.code === 1200) {
                // 更新可分拣数量
                this.currentSortingData.status = CONSTANT.DELIVER_STATE_KEY.PACK_WATI;
                if (this.$store.state.boxSetting && this.$store.state.boxSetting.autoLent == "true" && this.$store.state.boxSetting.selectBoxList && this.$store.state.boxSetting.selectBoxList.length) {
                  let boxTitles = "";
                  for (let i = 0; i < this.$store.state.boxSetting.selectBoxList.length; i++) {
                    boxTitles += this.$store.state.allTurnoverBoxsObj[this.$store.state.boxSetting.selectBoxList[i].id].title + "*" + this.$store.state.boxSetting.selectBoxList[i].count + " "
                  }
                  this.currentSortingData.boxTitles = boxTitles;
                }
                this.reflushWaitSortingCount();
                this.printData(this.currentSortingData);
              } else {
                this.querySortingListByOrder();
                this.$Notice.error({title: "分拣异常", desc: data.data.msg});
              }
            });
          }
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 标记、取消标记缺货
      editSortingLackStatus(sortingData) {
        this.currentSortingData = sortingData;
        return new Promise((resolve, reject) => {
          let lackStatus = 2;
          if (sortingData.lack_status == 2)
            lackStatus = 1;
          let param = {id: this.currentSortingData.id, lackStatus};
          this.currentSortingData.lack_status = lackStatus;
          editSortingLackStatus(param).then(data => {
            if (data.data.code === 1200) {
              this.$Notice.success({title: "标记成功",});
            }
          });
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 刷新分拣数据箱子
      flushPackingBox(packIds, checked) {
        setTimeout(() => {
          for (let j = 0; j < packIds.length; j++) {
            let currentIndex = 0;
            for (let i = 0; i < this.packDatas.length; i++) {
              if (this.packDatas[i].id == packIds[j]) {
                if (checked < 2 && this.packDatas[i].packing_type == 1) {
                  this.packDatas[i]._checked = checked;
                }
                currentIndex = i;
              }
            }
            getSortingDataById({id: packIds[j]}).then(data => {
              if (data.data.code === 1200) {
                this.packDatas[currentIndex].packingBoxCount = data.data.data.packingBoxCount;
                let boxIds = data.data.data.boxIds;
                // 整件自动装箱 打印箱签
                if (this.$store.state.softwareSetting.openBox == 1 && this.$store.state.softwareSetting.autoPrintBoxLabel == 1
                  && this.packDatas[currentIndex].packing_type == 2) {
                  for (let boxId of boxIds) {
                    this.$refs.globalPrint.printPackingBox([{
                      orderId: this.packDatas[currentIndex].order_id,
                      boxId: boxId
                    }]);
                  }
                }
              }
            })
          }
        }, 300);
      },
      // 名称查询
      /*changeTitleCallback(event) {
          this.querySortingListByOrder();
      },*/
      // 状态查询
      changeStatusCallback() {
        this.querySortingListByOrder();
      },
      // 取消装箱回调
      cancelBoxSubmitCallback() {
        this.flushPackingBox([this.currentSortingData.id]);
      },
      // 整件装箱
      doWholeBox(event) {
        this.currentSortingData = event;
        this.$Modal.confirm({
          title: "提示",
          content: "商品为整件装箱，根据拣出数生成箱子，如拣出数为2，则生成2个箱子，若拣出数为2.1，则生成3个箱子",
          onOk: () => {
            doPackingBoxByPackIds({packIds: [this.currentSortingData.id]}).then(data => {
              if (data.data.code === 1200) {
                this.flushPackingBox([this.currentSortingData.id]);
              }
            }).catch(err => {
              this.$Message.error(err);
            });
          },
          onCancel: () => {
          }
        });
      },
      // 开启图片拣货
      /*changeOpenSkuCover(event) {
          localStorage.setItem("openPic", event);
          this.openPicModal();
      },*/
      // 打印单个
      printData(data, autoPrint) {
        if (!autoPrint) {
          // 判断是否打印标签
          if (this.$store.state.softwareSetting.autoPrint == "2") {
            return;
          }
        }
        // 是否生成溯源码
        let imgBase64, qr, barcodeBase64;
        if (this.$store.state.platform_setting && this.$store.state.platform_setting.moduleArr.includes("traceSource")) {
          document.getElementById("qrcode").innerHTML = "";
          qr = new qrcode("qrcode", {
            text: h5PageUrl + "/s/#/?s=" + data.id,
            width: 80,
            height: 80,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: qrcode.CorrectLevel.L
          });
        }
        document.getElementById("jsbarcode").setAttribute("src", "");
        JsBarcode("#jsbarcode", data.id, {displayValue: false});
        barcodeBase64 = document.getElementById("jsbarcode").getAttribute("src");
        setTimeout(() => {
          let product = JSON.parse(JSON.stringify(data));
          if (qr) {
            imgBase64 = qr._oDrawing._elImage.src;
          }
          if (product) {
            product.barcode = barcodeBase64;
            product.sourceCode = imgBase64 ? imgBase64 : "";
            product.sku_name = product.product_name;
            // 分拣员
            if (this.$store.state.user && this.$store.state.user.userInfo) {
              product.sorterName = this.$store.state.user.userInfo.name || this.$store.state.user.userInfo.nick;
            }
            // 收货人
            if (product.buyer && product.buyer.reciver_name) {
              product.name = product.buyer.reciver_name;
              product.reciver_phone = product.buyer.reciver_phone;
            }
            if (product.is_weight == 1) {
              if (product.extend && product.extend.weight && product.extend.unit) {
                  // console.log(111, product.extend.weight, product.extend.unit);
                  product.sort_number = changeUnit(product.extend.weight, product.extend.unit, product.base_unit) + product.base_unit;
              } else {
                  // console.log(222, product.realWeight);
                  product.sort_number = product.realWeight + product.base_unit;
              }
            } else {
              product.sort_number = product.realWeight + product.product_cache.specifications;
            }
            product.sort_number_new = product.showSortingUnit;
            product.product_num_new = product.showUnit;
            if (product.sortingNo) {
              product.lineTitle += "-" + product.sortingNo;
            }
            product.specifications = product.product_cache ? product.product_cache.specifications : "";
            product.sku_goods_code = product.sku_goods_code;
            product.sku_goods_code_text = product.sku_goods_code;
            product.printTime = timeUtil.dateFormat(timeUtil.getFullDate(), "YYYY/MM/DD HH:mm");
            console.log("打印标签数据", product);
            if(this.printTemplate.template_grade == 2){ // 新版打印
              product.barcode = data.id;
              printByTemplateV2(this.printTemplate.printTemplate, [product], this.printTemplate.printIndex);
            }else{
              printByTemplate(product.id + "sorting", 1, this.printTemplate.printIndex, product, this.printTemplate,);
            }
          } else {
            this.$Message.error("当前没有分拣单");
          }
        }, 100);
      },
      // 查询打印模板信息
      getPrintTemplate() {
        let param = {type: 1};
        // 判断是否绑定模板
        let printInfo = localStorage.getItem("printSet");
        if (printInfo) {
          let printData = JSON.parse(printInfo);
          if (printData.fenjianPrintTemplate) {
            param.id = printData.fenjianPrintTemplate
          }
        }
        getPrintTemplate(param).then(data => {
          if (data.data.code == 1200) {
            console.log("拣货模板", data.data.data);
            if (!data.data.data) {
              // return this.$Notice.warning({
              // 	title: "未检测到分拣小票打印模板",
              //   duration: 0
              // })
              return this.$Notice.warning({
                title: "",
                duration: 0,
                render: h => {
                  return h('span', {
                    style: {"font-size": "22px", "margin-left": "10px", "line-height": "28px"}
                  }, [
                    '未检测到分拣小票打印模板，',
                    h('a', {
                      style: {"font-size": "22px"},
                      props: {type: 'success', size: 'small'},
                      on: {
                        click: () => {
                          this.$Notice.destroy();
                          this.$router.push({name: 'setting'});
                        }
                      }
                    }, '点击'),
                    '前往设置模版'
                  ])
                }
              });
            }
            this.printTemplate = {
              page: data.data.data.page,
              type: data.data.data.type,
              printTemplate: data.data.data.print_template,
              template_grade: data.data.data.template_grade
            };
            // 获取打印机索引
            let printInfoSe = localStorage.getItem("printSet");
            if (printInfoSe) {
              printInfoSe = JSON.parse(printInfoSe);
              this.printTemplate.printIndex = printInfoSe.fenjianPrint;
            }
          }
        })
      },
      // 检索sku名称
      searchOrderNameCallback(value) {
        this.searchOrderList = [];
        for (let i = 0; i < this.orderList.length; i++) {
          if (this.orderList[i].inner_no.includes(value) || this.orderList[i].deliver_user_name.includes(value)) {
            this.searchOrderList.push(this.orderList[i]);
          }
        }
      },
      // 选中检索sku
      selectOrderNameCallback(event) {
        for (let i = 0; i < this.searchOrderList.length; i++) {
          if (event == this.searchOrderList[i].inner_no) {
            this.currentOrder = this.searchOrderList[i];
            // this.querySkuBatchNoByOrders();
             document.getElementById('text' + this.searchOrderList[i].inner_no).scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
          }
        }
      },
      // 配送方查询回调
      changeDistributorCallback(event) {
        this.searchParams.distributor = event;
        this.querySortingByOrder();
      },
      // 选择供应商回调
      changeSupplierCallback(event) {
        this.searchParams.supplierId = event;
        this.querySortingByOrder();
      },
      // 查询订单中的周转物
      showOrderTurnover() {
        this.$refs.orderTurnover.showModal();
      },
      // 修改订单周转物回调
      updateOrderTurnoverCallback() {
        this.querySortingByOrder();
      },
      // 选择数据回调
      selectDataCallback(event, index) {
        this.selectDatas = [];
        for (let i = 0; i < this.packDatas.length; i++) {
          if (this.packDatas[i]._checked)
            this.selectDatas.push(this.packDatas[i]);
        }
      },
      // 查询订单装箱列表
      showOrderBoxList() {
        this.$refs.orderBoxList.showOrderBoxModal({orderId: this.currentOrder.order_id});
      },
      // 装箱回调
      submitJoinBoxCallback(data) {
        this.selectDatas = [];
        this.flushPackingBox(data.packIds, 0);
        // this.querySortingListByOrder();
      },
      // 取消装箱
      cancelBox(item) {
        this.currentSortingData = item;
        this.$refs["cancelBox"].queryPackingBoxList(item);
      }
    },
    /*computed: {
        storeComplete() {
            return this.$store.state.storeComplete
        }
    },*/
    watch: {
      "$store.state.storeComplete"(to, old) {
        // console.log(11, to)
        // console.log(22, old)
        console.log(this.$store.state)
        this.searchParams.dateType = this.$store.state.dateType;
        this.searchParams.packTime = [this.$store.state.sortingTimeSetting.sortingStartTime, this.$store.state.sortingTimeSetting.sortingEndTime];
        this.searchParams.sort = this.$store.state.softwareSetting.sortingMoved;
        this.querySortingByOrder();
      }
    },
    mounted() {
      // console.log("查询2")
    },
    created() {
      if (this.$store.state.storeComplete) {
        this.querySortingByOrder();
      }
      this.queryCarLine();
      this.getPrintTemplate();
      /*let openPic = localStorage.getItem("openPic");
      if (openPic) {
          this.openPic = openPic == "true" ? true : false;
      }*/
    },
    activated() {
      if (this.$store.state.storeComplete) {
        this.querySortingListByOrder();
        this.$refs.weightReading.showUnitValue();
      }
    }
  }
</script>

<style scoped lang="less">
  .usePageBox {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-top: 50px;
    position: relative;
    box-sizing: border-box;

    .topBox {
      top: 0;
      left: 0;
      width: 100%;
      height: 50px;
      display: flex;
      padding: 0 10px;
      position: absolute;
      align-items: flex-start;

      .leftBox {
        width: 240px;
      }

      .rightBox {
        flex-grow: 1;
        display: flex;
        padding-left: 20px;
        align-items: center;
        box-sizing: border-box;
        justify-content: space-between;
      }
    }

    .contentBox {
      width: 100%;
      height: 100%;
      display: flex;

      .leftBox {
        width: 240px;
      }

      .rightBox {
        flex-grow: 1;
        padding: 0 20px;
        overflow: hidden;
        overflow-y: scroll;
        box-sizing: border-box;
      }

      .rightBox::-webkit-scrollbar {
        width: 30px;
        height: 100%;
        background-color: #f0faff;
      }

      .rightBox::-webkit-scrollbar-thumb {
        border-radius: 6px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background-color: #666666;
      }
    }
  }

  .skuBoxArea {
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }

  .skuBoxArea::-webkit-scrollbar {
    display: none;
    height: 100%;
    background-color: #17233d;
  }

  .childContentBox {
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }

  .childContentBox::-webkit-scrollbar {
    display: none;
  }

  .skuBox {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
    background-color: #17233d;
  }

  .skuBox::-webkit-scrollbar {
    width: 30px;
    height: 100%;
    background-color: #f0faff;
  }

  .skuBox::-webkit-scrollbar-thumb {
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #666666;
  }

  .skuItem {
    width: 100%;
    display: flex;
    min-height: 60px;
    color: #F0F0F0;
    padding: 5px 8px;
    align-items: center;
    justify-content: flex-start;

    &:hover {
      color: #F0F0F0;
      background-color: #21345c !important;
    }

    &.active {
      color: #595959;
      border-left: 6px solid #4c70db;
      background-color: #f0faff !important;
    }
  }

  /*.skuItem:hover {
      color: #F0F0F0;
      background-color: #21345c !important;
  }*/

  .countNum {
    display: inline-block;
    margin-left: 6px;
    height: 100%;

    .numtext {
      display: flex;
      height: 20px;
      font-size: 18px;
      line-height: 18px;
      color: #ffffff;
      min-width: 27px;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
      background-color: #fb4747;
    }
  }

  .cardLeft {
    width: 75%;
    // float: left;
    height: 100%;
    background-color: #6699CC;
    min-height: 150px;
    color: #F0F0F0
  }

  .cardRight {
    top: 0;
    right: 0;
    width: 25%;
    // float: left;
    position: absolute;
    height: 100%;
    min-height: 150px;

    .top {
      // height: 75px;
      height: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px #dedede solid;
      border-radius: 0;
      text-align: center;
      // line-height: 75px;
      width: 75px;
    }

    .buttom {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dedede;
      border-radius: 0;
      border-top: none;
      text-align: center;
      // line-height: 75px;
      width: 75px;
    }
  }

  .areaBox {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/view/sorting/orderSorting.vue